import React from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Redirect,
    Route
  } from "react-router-dom";
import AboutUs from 'pages/aboutUs';
import ContactUs from 'pages/contactUs';
import Home from 'pages/index';
import CoinsLanding from 'pages/coins/index.js';
import Commission from "pages/commission";
import {  useSelector } from 'react-redux';
import { setI18nConfig } from 'i18n/index';
import Register from 'pages/panel/auth/Register';
import Login from 'pages/panel/auth/login/index.jsx';
import WebLayout from '../layouts/webLayout/index.jsx';
import PanelLayoutRoute from 'layouts/panelLayout/index.jsx';

import BareLayout from '../layouts/bareLayout/index';
import { selectLanguage } from 'store/selector/language';
import Security from 'pages/security';
import ShowAllMarkets from 'pages/showAllMarkets'
import Faq from "pages/faq";
import UserPlan from 'pages/userPlan';
import Setting from 'pages/panel/setting/index';
import Wallet from 'pages/panel/Wallet/index';
import Support from 'pages/panel/support';
import Report from 'pages/panel/report';
import UserView from 'pages/panel/userView';
import PageNotFound from 'layouts/404';
import Referral from 'pages/referral';
import ScrollToTop from './scrollToTop';
import UserGuide from 'pages/userGuide';
import Guide from 'pages/guide';
import Rules from 'pages/rules';
import NotFoundPage from 'layouts/404'

export default function HomeRoute(){
  const users=useSelector(selectLanguage);
  const{language}=users;
  React.useEffect(() => {
    setI18nConfig();
  }, []);
  
    return(
      <div className={language.name === 'fa' ? "style-rtl" : "style-ltr"}>
        <Router>
          <ScrollToTop>
        <Switch>
        <WebLayout path="/" component={Home} exact />
        <BareLayout path="/register" component={Register} />
        <BareLayout path="/login" component={Login} />
        <WebLayout path="/about-us" component={AboutUs} />
        <WebLayout path="/contact-us" component={ContactUs} />
        <WebLayout path="/user-guide" component={UserGuide} />
        <WebLayout path="/user-plan" component={UserPlan} />
        <WebLayout path="/guide/:id" component={Guide} />
        <WebLayout path="/commission" component={Commission} />
        <WebLayout path="/404" component={NotFoundPage} />
        <WebLayout path="/show-all-markets" component={ShowAllMarkets} />
        <WebLayout path="/coins/:id" component={CoinsLanding} />
        <WebLayout path="/rules" component={Rules} />
        <WebLayout path="/faq" component={Faq} />
        <WebLayout path="/security" component={Security} />
        <WebLayout path="/referral" component={Referral} />
        <PanelLayoutRoute  path="/setting" component={Setting} />
        <PanelLayoutRoute  path="/wallet" component={Wallet} />
        <PanelLayoutRoute  path="/support" component={Support} />
        <PanelLayoutRoute  path="/report" component={Report} />
        <PanelLayoutRoute  path="/user-view" component={UserView} />
        <Route path="/404" component={PageNotFound} />
        <Redirect to="/404" />
        </Switch>
        </ScrollToTop>
      </Router>
      </div>
    )
}

